module.exports = __webpack_public_path__ + "img/sub1.cee0b5c7.png";